import script from "./InventoryItem.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryItem.vue?vue&type=script&setup=true&lang=js"

import "./InventoryItem.vue?vue&type=style&index=0&id=41b4e4c3&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41b4e4c3"]])

export default __exports__